<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item">
          <a class="nav-link text-dark d-flex" data-scroll href="#profile">
            <i class="material-symbols-rounded text-lg me-2">person</i>
            <span class="text-sm">{{ $t('user.Profile') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#user-info">
            <i class="material-symbols-rounded text-lg me-2">receipt_long</i>
            <span class="text-sm">{{ $t('user.User_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#address">
            <i class="material-symbols-rounded text-lg me-2">contacts</i>
            <span class="text-sm">{{ $t('user.Address') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#password">
            <i class="material-symbols-rounded text-lg me-2">lock</i>
            <span class="text-sm">{{ $t('user.Password') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#sessions">
            <i class="material-symbols-rounded text-lg me-2">settings_applications</i>
            <span class="text-sm">{{ $t('user.Sessions') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#profileimage">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('user.Profile_image') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#signatureimage">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('user.Signature_image') }}</span>
          </a>
        </li>  
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('user.Delete_user') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditUserSideNav",
  };
  </script>
  